import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-datetime',
    templateUrl: './datetime.component.html',
    styleUrls: ['./datetime.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DatetimeComponent extends InputComponent {
    clear = output<void>();
    timeControl: FormControl = new FormControl();

    constructor() {
        super();

        if (this.model && this.model instanceof Date) {
            this.timeControl.setValue(this.model);
        } else {
            this.timeControl.disable();
        }
    }

    public onDateChange(): void {
        const value = this.formControl()?.value;
        const time = this.timeControl.value as Date;
        if (!time || time instanceof Date === false) {
            this.timeControl.setValue(value);
            this.timeControl.enable();
        }
    }

    public onTimeChange(event: any): void {
        const time = event.value as Date;
        if (!time) return;

        const formControl = this.formControl();
        if (formControl?.value) {
            const date = formControl?.value as Date;
            if (date) {
                date.setHours(time.getHours());
                date.setMinutes(time.getMinutes());
                formControl?.setValue(date);
            } else {
                formControl?.setValue(time);
            }
        }
    }

    public onClear(): void {
        const formControl = this.formControl();

        formControl?.patchValue(null);
        formControl?.markAsDirty();
        this.timeControl.patchValue(null);
        this.timeControl.disable();
        this.clear.emit();
    }
}
